import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { ADPResourceService, SitefinityImage } from 'digital-core';
import { IDevice} from 'src/app/model/sitefinity/IDashboard';

@Component({
  selector: 'pgh-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss']
})
export class DeviceComponent {
  @Input() device: IDevice;
  @Input() totalDevices: number = 0;
  @Input() registeredDevices: number = 0;
  @Input() notRegisteredDevices: number = 0;
  @Input() isMobileDevice: boolean = false;
  @Input() isMobilePlan: boolean = false;
  @Input() isDisabledController: boolean = false;
  isMobileSize: boolean = false;
  deviceRoute: string;
  smartDeviceImage: SitefinityImage;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private resourceService: ADPResourceService) {
      this.deviceRoute = this.resourceService.getPortalSetting("URL_MyDevices").Value;
      this.smartDeviceImage = this.getResource('Global_Dashboard_Devices_Image');
      this.breakpointObserver.observe([
        Breakpoints.XSmall
      ]).subscribe(result => {
        this.isMobileSize = result.matches;
      });
  }

  getResource(name: string) {
    let resourceValue = this.resourceService.getPortalImage(name);
    return resourceValue;
  }
}
